import { render, staticRenderFns } from "./CompareWordingTips.vue?vue&type=template&id=647e6596"
import script from "./CompareWordingTips.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompareWordingTips.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CompareWordingTips.vue?vue&type=style&index=0&id=647e6596&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports